import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { AppLayoutComponent } from './features/aplication/app-layout/app-layout.component';
import { ChatResolver } from './features/chat/chat.resolver';
import { BaneoGuard } from './guards/baneo.guard';
import { LoadingComponent } from './features/loading/loading.component';
import { LandingLayoutComponent } from './landing/landing-layout/landing-layout.component';

export const routes: Routes = [
  {
    path: 'app',
    data: { ssr: false },
    canActivate: [authGuard, BaneoGuard],
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./features/aplication/application.routes').then(m => m.APP_ROUTES)
      },
      
      
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
      },
      
    ]
  },
  {
    path: 'admin',
    component: AppLayoutComponent,
    canActivate: [AdminGuard],
    loadChildren: () => import('./features/aplication/admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'chat/:id',
    data: { ssr: false },
    loadChildren: () => import('./features/chat/chat.routes').then(m => m.CHAT_ROUTES),
    canActivate: [authGuard, BaneoGuard],
    resolve: { usuario: ChatResolver }
  },
  {
    path: 'auth',
    data: { ssr: false },
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'baneado',
    data: { ssr: false }, // 🚀 nueva ruta
    loadComponent: () => import('./features/baneado/baneado.component').then(m => m.BaneadoComponent)
  },
  {
    path: 'loading',
    data: { ssr: false },
    component: LoadingComponent
  },
  {
    path: '',
    component: LandingLayoutComponent,
    data: { ssr: true },
    loadChildren: () => import('./landing/landing.routes').then(m => m.LANDING_ROUTES)
  },
  { path: '**', redirectTo: '' }
];